import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'stars-banner',
    templateUrl: './stars.component.html',
    styleUrls: ['./stars.component.css'],
    standalone: false
})
export class StarsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
